import React, { useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import { Empty,Pagination } from "antd";

import useJDStore from "../../store/jd.store";

import Table from "../Table";

import "./assignedJds.scss";
import Filter from "../filter";

export default function AssignedJds(props) {
  const navigate = useNavigate();
  const { getAllJdsPagination, jdData,allJDsCount } = useJDStore();
  useEffect(() => {
    //getAllJds();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  const titleList = [
    "Sr. No.",
    "Assigned On",
    "Client",
    "TA",   
    "Job Title",
    "Priority",
    "JD Status", 
    "Total Resumes",
    "SPOC",
    "Assigned To",
    "BU/Project Name",
    "Hiring Manager",
  ];

  const GetTeamAssignment =(jds)=>{
    var assignedTeam=''
    jds?.JDAssignment?.Assignments?.map((assign,idx)=>{
      if (assignedTeam === ''){
        assignedTeam = assign.AssignedToName;
      }else{
        assignedTeam = assignedTeam +','+assign.AssignedToName;
      }
      
     return })

     return assignedTeam
  }

  const jdsDetailData = jdData?.map((jds, idx) => {
    return {
        id:  idx + 1 + (pageSize*(currentPage-1)),
        date_added: jds?.JDOther.PostingDate,  
        client_name: jds?.JDClient.ClientName,
        ta_name: jds?.JDClient.TaName,
        title: '['+jds?.QhCompanyJID+'] '+jds?.JDDetails.Title,
        priority: jds?.JDOther.Priority,
        status:jds?.JDProject.ReqStatus,
        total_resumes:jds?.JDResumeList?.length>0?jds?.JDResumeList?.length:0,
        SPOC: jds?.JDAssignment?.Spoc,
        assignedTo: GetTeamAssignment(jds),
        bu: jds?.hiring_project_team_name!=null?jds?.hiring_project_team_name:"--",
        hiring_project_team_name: jds?.hiring_project_team_name!=null?jds?.hiring_project_team_name:"--",
      }
  });

  return (
    <div className="jds-wrapper">
      <div>
      <Filter
        filtername = {"getAllJdsPagination"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"} 
        initClient={"All"}
        pageNo = {currentPage}
        pageSize ={pageSize}  
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers 
        enableTAs     
        handleFilter={getAllJdsPagination}
        pageHandler = {setCurrentPage}  
      />
      <div></div>
      </div>

      {jdsDetailData?.length > 0 ? (
        <Table
          isClickable={true}
          isJDPage={true}
          titleList={titleList}
          data={jdsDetailData}
          columnWidth={[
            50, 100, 200, 100, 200, 100, 100, 100, 100, 100, 200, 200,
          ]}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={allJDsCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />        
    </div>
  );
}
